// TODO: вынести в компоненты модуля, так как fsd widgets не должен управлять состоянием

import { ButtonWithIcon } from '@ui/button';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { simpleMix } from '@entities/simple-mix';
import { StrictMode, useEffect, useId, useRef } from 'react';
import {
  $showZoomButton,
  $zoomModeEnabled,
  mapLoaded,
  toggleZoomMode,
  $contextMenuEnabled,
  $contextMenuCoords,
  closeContextMenu,
  $contextMenuStatus,
} from '../model';
import { map } from './model';
import styles from './styles.module.css';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import {
  $agricultureById,
  editAgricultureModal,
  showFillModal,
} from '@@/agriculture/store/agriculture.store';
import { emptyBag, mixBag, removeBag, unmixBag } from '@features/edit-bag/model';
import { useBag } from '@entities/warehouse/store';
import { useNavigate } from 'react-router';
export const WarehouseMap = ({ className = '' }) => {
  const showZoomButton = useStore($showZoomButton);
  const navigate = useNavigate();
  const zoomModeEnabled = useStore($zoomModeEnabled);
  const contextMenuEnabled = useStore($contextMenuEnabled);
  const contextMenuStatus = useStore($contextMenuStatus);
  const contextMenuCoords = useStore($contextMenuCoords);
  const agricultureById = useStore($agricultureById);
  const mixedBagsCount = useStore(simpleMix.$mixedBagsCount);
  const { MAX_SIMPLE_MIXING_ITEMS_CNT } = simpleMix;
  const ctxmRef = useRef(null);
  const containerDomRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef(
    new ResizeObserver(() => {
      map.resize();
    }),
  );

  useEffect(() => {
    ymaps.ready(() => {
      map.init('yviewer', containerDomRef.current);
      mapLoaded();
    });

    if (containerDomRef.current) {
      observerRef.current.observe(containerDomRef.current);
    }

    return () => {
      map.dispose();
      observerRef.current.disconnect();
    };
  }, []);

  const items = [];

  if (contextMenuEnabled) {
    const bag = useBag(contextMenuEnabled.id);

    if (simpleMix.isBagMixed(bag.id)) {
      items.push({
        label: 'Удалить из бункера',
        onClick: () => {
          unmixBag({ bagId: bag.id });
        },
      });
    } else if (!bag.agricultureId) {
      items.push(
        {
          label: 'Заполнить',
          onClick: () => {
            showFillModal(contextMenuEnabled);
          },
        },
        {
          label: 'Удалить',
          onClick: () => {
            removeBag({ bagId: contextMenuEnabled.id, warehouseId: 0 });
          },
        },
      );
    } else {
      if (
        agricultureById[bag.agricultureId as number]?.mixable &&
        mixedBagsCount < MAX_SIMPLE_MIXING_ITEMS_CNT
      ) {
        items.push({
          label: 'Замиксовать',
          onClick: () => {
            mixBag({ bagId: bag.id });
            mixedBagsCount === MAX_SIMPLE_MIXING_ITEMS_CNT - 1 &&
              navigate('/mixing-simple');
          },
        });
      }
      items.push(
        {
          label: 'Редактировать',
          onClick: () => {
            editAgricultureModal(contextMenuEnabled);
          },
        },
        {
          label: 'Опустошить',
          onClick: () => {
            emptyBag({ bagId: contextMenuEnabled.id, warehouseId: 0 });
          },
        },
      );
    }
  }

  return (
    <StrictMode>
      <figure className={classNames([styles.map, className])}>
        <div className={styles.container} id="yviewer" ref={containerDomRef} />
        {showZoomButton && (
          <ButtonWithIcon
            icon="ZoomIcon"
            title={zoomModeEnabled ? 'Выключить ZOOM' : 'Включить ZOOM'}
            data-disabled={!zoomModeEnabled}
            className={styles.zoomButton}
            onClick={() => toggleZoomMode(!zoomModeEnabled)}
          />
        )}
      </figure>

      <ContextMenu
        className={styles.contextMenu}
        style={{ top: contextMenuCoords[1], left: contextMenuCoords[0] }}
        items={items}
        anchorRef={ctxmRef}
        isOpen={contextMenuStatus}
        onClick={() => closeContextMenu()}
      />
    </StrictMode>
  );
};
